<template>
  <div class="limitWrap">
    <div class="head" v-if="Xtype!=1"><span @click="handleReturn"></span>选择认证类型</div>
    <div :class="[{main:Xtype==1},'limitMain']">
      <div class="limitMain_top">
        <div class="limitMain_type">
          <div class="top">
            <span><img src="@/assets/image/pIcon.png"></span>个体工商户
            <router-link to="/open-info?type=1">立即认证</router-link>
          </div>
          <div class="info">适合营业执照名称或类型包含个体工商户、个人独资企业的公司，需要提供营业执照</div>
        </div>
        <div class="limitMain_type">
          <div class="top">
            <span><img src="@/assets/image/cIcon.png"></span>企业/公司
            <router-link to="/open-info?type=2">立即认证</router-link>
          </div>
          <div class="info">适合营业执照名称或类型包含有限制责任公司、股份公司，需要提供营业执照</div>
        </div>
      </div>
      <div class="limitMain_info">
        <h6>选项说明</h6>
        <div class="infoItem">
          <div class="title">个体工商户</div>
          <p>营业执照“类型”处显示为“个体工商户”</p>
          <div class="img">
            <img src="@/assets/image/pImg.png" />
          </div>
        </div>
        <div class="infoItem">
          <div class="title">企业/公司</div>
          <p>营业执照“类型”处显示为“***公司/企业/农民专业合作社”等</p>
          <div class="img">
            <img src="@/assets/image/cImg.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: null,
      Xtype:null,
      token:'',
    }
  },
  created(){
    this.Xtype = Number(this.$route.query.Xtype)
    this.token = this.$route.query.token
    sessionStorage.setItem('token',this.token)
    sessionStorage.setItem('Xtype',this.Xtype)
    sessionStorage.removeItem('data')
  },
  methods: {
    handleReturn(){
      // 调用原生方法
      setTimeout(()=>{
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.webkit.messageHandlers.popViewController.postMessage(null);
        } else if (navigator.userAgent.match(/android/i)) {
          window.android.appFinish();
        }
      }, 500)
    },
  }
}
</script>
<style lang="scss" scoped>
.limitWrap {
  .head{
    width: 100%;
    height: 1.173333rem;
    line-height: 1.173333rem;
    text-align: center;
    font-size: 0.453333rem;
    font-weight: bold;
    color: #333333;
    position: fixed;
    top: 0;
    background: #fff;
    z-index: 2200;
    span{
      width:0.64rem;
      height:0.64rem;
      background: url(../assets/image/back.png) no-repeat center;
      background-size: contain;
      display: inline-block;
      position: absolute;
      left: 0.426667rem;
      top: 0.266667rem;
    }
  }
  .limitMain{
    margin-top: 1.173333rem;
    padding: 0.24rem 0;
    &.main{
       margin-top: 0;
    }
  }
  .limitMain_top{
    padding: 0 0.426667rem;
    font-size: 0.346667rem;
    color: #999999;
    border-bottom: 0.213333rem solid #F8F8F8;
    .limitMain_type{
      padding: 0.426667rem 0;
      &:not(:last-child) {
        border-bottom: 1px solid #E5E5E5;
      }
      .top{
        line-height: 0.746667rem;
        overflow: hidden;
        color:#333;
        font-size: 0.4rem;
      }
      span{
        width: 0.746667rem;
        height: 0.746667rem;
        float: left;
        margin-right: 0.32rem;
        img{
          width: 100%;
        }
      }
      a{
        width: 2.133333rem;
        height: 0.8rem;
        line-height: 0.8rem;
        background: #F3474A;
        opacity: 1;
        border-radius: 4px;
        font-size: 0.346667rem;
        float:right;
        color:#fff;
        text-align: center;
      }
      .info{
        padding-left: 80px;
        margin-top: 0.2rem;
      }
    }
  }
  .limitMain_info{
    padding:0.426667rem;
    font-size: 0.346667rem;
    font-weight: 400;
    color: #999999;
    opacity: 1;
    h6{
      font-weight: 500;
      font-size: 0.346667rem;
      color: #666666;
    }
    .title{
      font-size: 0.373333rem;
      font-weight: 600;
      color: #333333;
      margin: 0.266667rem 0 0.106667rem;
    }
    .img{
      background: #F2F2F2;
      text-align: center;
      padding: 0.133333rem 0;
      margin-top: 0.266667rem;
      img{
        width: 50%;
      }
    }
  }
}
</style>